import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
      showInFilter: false,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    {
      Header: "จำนวนประเภทสินค้า",
      accessor: "count_type_product",
      showInFilter: false,
    },
    {
      Header: "จำนวนทั้งหมด",
      accessor: "count_product_amount",
      showInFilter: false,
    },
    { Header: "ราคาทุน", accessor: "total_product_price", showInFilter: false },
    { Header: "วันที่ซื้อเข้า", accessor: "created_date", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          {/* {console.log("display row id", row)} */}
          <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeRowId === row.id}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                setViewProduct(row);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("row", row);
                setProduct(row);
                handleModalOpen();
                handleMenuClose();
              }}
            >
              <BorderColorIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>แก้ไข</span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("Delete product with ID:", row.original.id);
                handleMenuClose();
              }}
            >
              <LocalPrintshopIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>
                พิมพ์ใบรับซื้อสินค้า
              </span>
            </MenuItem>
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
